import axios from 'axios';

const patternPassword = (val) => {
  const isEmpty = !val;
  const lessThen8Symbols = val.length < 8;
  const noDigits = !/\d/.test(val);
  const hasSpaces = /\s/.test(val);
  const noCapitalLetter = !/[A-Z]/.test(val);
  const noLowercaseLetter = !/[a-z]/.test(val);
  const noSpecialCharacter = !/(?=.*[!@#$%^&*.()])/.test(val);
  return {
    isEmpty,
    lessThen8Symbols,
    noDigits,
    hasSpaces,
    noCapitalLetter,
    noLowercaseLetter,
    noSpecialCharacter,
  };
};
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      user: {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        position: '',
        dealer_centre: '',
        email: '',
        password: '',
        passwordConfirm: '',
        address: '',
        checkedRules: false,
        checkedPers: false,
        allow_push: false,
        role: 'seller',
        dealer_id: null,
        type: null,
        inn: '',
        business_type_id: null,
        business_type_ids: [],
        object_id: null,
        distributor_ids: null,
        companyName: '',
        urAddress: '',
        factAddress: '',
        disable_preloaded: false,
        has_middlename: false,
      },
      sameAddresses: false,
      company: null,
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        inn: v => (!v || !v.length || v.length === 10 || v.length === 12) || 'ИНН может содержать 10 или 12 символов',
        code: v => !!v || 'Укажите проверочный код',
        factAddress: v => !!v || 'Укажите адрес',
        companyName: v => !!v || 'Укажите валидный инн',
      },
      valid: false,
      profile: {},
      searchPoint: '',
      searchAddress: '',
      pointName: null,
      suggestions: [],
      isLoadingSuggest: false,
      objects: [],
      distributors: [],
      business_types: [],
      points: [],
      addresses: [],
      customObject: '',
      cities: [],
      searchCity: '',
    };
  },
  watch: {
    'user.password': (value) => {
      const messageWrapper = document.getElementById('password_msg');
      messageWrapper.innerHtml = '';
      messageWrapper.innerText = '';
      const checkPassword = patternPassword(value);
      const resultObject = {
        lessThen8Symbols: 'минимум 8 символов',
        noDigits: '1 цифра',
        noCapitalLetter: '1 заглавная латинская буква',
        noLowercaseLetter: '1 прописная латинская буква',
        noSpecialCharacter: '1 специальный символ',
        hasSpaces: 'без пробелов',
      };
      const div = document.createElement('div');
      const beginning = document.createElement('span');
      if (checkPassword.isEmpty) {
        return;
      }
      div.appendChild(beginning);
      Object.keys(resultObject).forEach((key) => {
        const messageDiv = document.createElement('div');
        const color = checkPassword[key] ? 'red' : 'green';
        const icon = document.createElement('i');
        icon.style.color = color;
        icon.innerHTML = checkPassword[key] ? '✗' : '✓';
        messageDiv.appendChild(icon);
        const message = document.createElement('span');
        message.innerHTML = resultObject[key];
        message.style.color = color;
        message.style.marginLeft = '5px';
        messageDiv.appendChild(message);
        div.appendChild(messageDiv);
      });
      messageWrapper.appendChild(div);
    },
    // eslint-disable-next-line func-names,no-unused-vars
    'user.city_id': function (_) {
      this.pointName = null;
      this.user.dealer_id = null;
    },

    // eslint-disable-next-line func-names,no-unused-vars
    pointName(_) {
      this.user.dealer_id = null;
    },

    searchPoint(name) {
      const app = this;
      if (name && name.length) {
        app.user.city_id && app.$store.getters.ax.post('profiles/api/register/load-dealer-names', {
          city_id: app.user.city_id,
          name,
        })
          .then((result) => {
            app.points = result.data.names;
          });
      }
    },
    searchCity(city) {
      const app = this;
      if (city && city.length) {
        app.$store.getters.ax.post('profiles/api/location/cities', { term: city, limit: 30 })
          .then((result) => {
            app.cities = result.data.cities;
          });
      }
    },

    searchAddress(address) {
      const app = this;
      const data = {};
      if (app.pointName) {
        data.name = app.pointName;
        data.city_id = app.user.city_id;
        if (address) {
          data.address = address;
        }
        this.$store.getters.ax.post('profiles/api/register/load-dealer-addresses', data)
          .then((result) => {
            this.addresses = result.data.addresses;
          });
      }
    },
    // eslint-disable-next-line func-names
    'user.inn': function (val) {
      // this.user.companyName = '';
      if (val && val.length >= 10) {
        this.$store.getters.axl.post('profiles/api/dealers/find-by-inn', { inn_search: val, type_id: 1 })
          .then((result) => {
            const company = result.data.data[0];
            console.log(company);
            if (company) {
              this.company = company;
              this.user.companyName = company.organization_name;
              this.user.urAddress = company.address;
            }
          })
          .catch((error) => {
            this.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsUnregistared() { return this.type === 'sms_noprofile_or_unregistered'; },
    isSmsNoProfile() { return this.type === 'sms_noprofile' || this.type === 'sms_profile_unregistered'; },
    isEmailNoProfile() { return this.type === 'email_noprofile'; },

    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const { profile } = response.data;
          if (profile) {
            app.disable_preloaded = true;
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
            app.user.factAddress = profile.position;

            if (profile.city) {
              app.user.city_id = profile.city.id;
            }
            if (profile.dealer) {
              app.user.dealer_id = profile.dealer.id;
              app.user.inn = profile.dealer.inn;
              app.user.companyName = profile.dealer.name;
              app.user.urAddress = profile.dealer.address;
            }
            if (profile.middle_name && profile.middle_name.length > 0) {
              app.has_middlename = true;
            }

          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id)?.focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        dealer_id: '',
        role: 'seller',
        city_id: null,
        checkedRules: false,
        checkedPers: false,
        allow_push: false,
        type: null,
        inn: '',
        business_type_id: null,
        business_type_ids: [],
        object_id: null,
        distributor_ids: null,
        companyName: '',
        urAddress: '',
        factAddress: '',
        customObject: '',
      };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.cities = [];
      this.searchPoint = '';
      this.points = [];
      this.pointName = null;
      this.searchAddress = '';
      this.addresses = [];

      this.Focus('regPhone');
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = { type: 'sms_noprofile_or_unregistered' };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsUnregistared) {
        url = 'api/token/get-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: 'sms_noprofile_or_unregistered', code: app.code };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsUnregistared) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = { ...app.user };
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl.post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async GetObjects() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/location/objects')
        .then((result) => {
          app.objects = result.data.objects;
        });
    },
    async GetBusinessTypes() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/location/business-types')
        .then((result) => {
          app.business_types = result.data.types;
        });
    },
    async GetDistributors() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/location/distributors')
        .then((result) => {
          app.distributors = result.data.distributors;
        });
    },
    onDialogRules() {
      if (this.pageRules) {
        this.dialogRules = true;
      }
    },
    TypeChange() {
      this.user.inn = '';
      this.user.business_type_id = null;
      this.user.business_type_ids = [];
      this.user.object_id = null;
      this.user.distributor_ids = null;
      this.user.companyName = '';
      this.user.urAddress = '';
      this.user.factAddress = '';
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
        }
      });
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
    this.GetObjects();
    this.GetBusinessTypes();
    this.GetDistributors();
  },
};
